import React, { useState } from "react";
import styles from "./viewTreatment.module.scss";
import { CloseWarning } from "../CloseWarning";
import { signedLockedAccess } from "../../../utils";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Button, Form } from "../../primary";
import { assessmentRbacChecker } from "../../../utils/rbac";
import { CANCEL_BTN, CANCEL_ID, SAVE_BTN, SUBMIT_ID } from "../../../constants";
import { TreatmentDropDownItemNew } from "../TreatmentDropDownItem";

export const TreatmentEditForm = ({
  editData,
  setFormChangesConfirm,
  isPrimSec,
  setIsPrimSec,
  saveData,
  setEditable,
  dressing,
  setCloseWarningSec,
  viewScreen,
  dropValue,
  setGetValueDrop,
  handleCancel,
  isReadOnly,
}) => {
  const { handleSubmit } = useForm();
  const assessmentDetails = useSelector((state) => state.patient.detailAssessment);
  const [closeWarning, setCloseWarning] = useState(false);

  const treatmentViewData = useSelector((state) => state.patient.treatmentViewData);
  const patientData = useSelector((state) => state.patient.detailViewData);
  const userDetails = useSelector((state) => state.user);

  const hideButtons = assessmentRbacChecker(userDetails?.role, patientData?.isOwnCustomer);

  const yesFun = () => {
    setCloseWarning(false);
  };

  const noFun = () => {
    setCloseWarning(false);
  };

  const doSubmit = () => {
    const sub = treatmentViewData?.flatMap((item) => {
      if (Array.isArray(item.value)) {
        return item.value.map((val) => ({
          key: item.key,
          value: val,
          isRecommended: item.isRecommended,
        }));
      }
      return item;
    });

    saveData(sub);
    setEditable(false);
  };

  const getOptValue = () => {
    if (dressing === "primary" || dressing === "secondary") {
      setIsPrimSec(true);
    }

    if (setCloseWarningSec) {
      setCloseWarningSec(false);
    }
    setFormChangesConfirm(true);
  };

  return (
    <>
      {closeWarning && (
        <CloseWarning message={`Are you sure you would like to proceed with your secondary dressing selection?`} yesFn={yesFun} noFn={noFun} />
      )}
      {signedLockedAccess(assessmentDetails?.assessmentStage) ? (
        <Form setFormChangesConfirm={setFormChangesConfirm} directChanges={isPrimSec} className="col-12 p-0" onSubmit={handleSubmit(doSubmit)}>
          {editData &&
            Array.isArray(editData) &&
            editData.length > 0 &&
            editData.map((item, index) => {
              return (
                <TreatmentDropDownItemNew
                  index={item.key}
                  key={index}
                  id={item.key}
                  name={item.key}
                  label={`${item.name}`}
                  classes={{
                    column: `col-12 ${styles.col_spec} d-flex mb-2`,
                    inputClassName: styles.basic_select,
                    inputColumn: `col-6 p-0`,
                    labelClassName: `col-12 p-0`,
                  }}
                  listOptions={item.options}
                  getData={getOptValue}
                  viewScreen={viewScreen}
                  dressing={dressing ? dressing : "secondary"}
                  dropValue={dropValue}
                  setGetValueDrop={setGetValueDrop}
                  disabled={isReadOnly}
                />
              );
            })}
          {hideButtons && editData?.length !== 0 ? (
            <div className="row">
              <div className="mt-4 pt-2 col-sm-12 p-0">
                <div className="offset-5">
                  {/* Save Button */}
                  <Button classes={{ className: `btn ${styles.btn_custom} ${styles.btn_small}` }} type="submit" id={SUBMIT_ID}>
                    {SAVE_BTN}
                  </Button>
                  {/* Cancel button  */}
                  <Button
                    classes={{ className: `btn ${styles.btn_custom} ${styles.btn_small_cancel} handlecancel` }}
                    id={CANCEL_ID}
                    onClick={handleCancel}
                    type="button"
                  >
                    {CANCEL_BTN}
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </Form>
      ) : (
        "This wound assessment is signed and locked, cannot be updated."
      )}
    </>
  );
};
